import { rankingItems } from '@/mocks/homepage';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          热搜榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          实时更新的网红爆料热度排行榜，吃瓜必看
        </p>
        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 border-b border-background-200 last:border-b-0 cursor-pointer hover:bg-background-100 transition-colors ${
                index === 0 ? 'bg-primary-50/50 rounded-t-xl' : ''
              } ${index === rankingItems.length - 1 ? 'rounded-b-xl' : ''}`}
            >
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                {item.rank <= 3 ? (
                  <span
                    className={`text-lg font-bold font-heading ${
                      item.rank === 1
                        ? 'text-primary-500'
                        : item.rank === 2
                          ? 'text-accent-500'
                          : 'text-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-semibold text-foreground-500">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.heat}</p>
              </div>
              <div className="w-6 h-6 flex items-center justify-center shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-primary-500 text-sm font-bold"></i>}
                {item.change === 'new' && <span className="text-xs font-bold text-accent-500">NEW</span>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-300 text-sm"></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}